export const mainDrawerDimen = {
  open: {
    width: 300,
  },
  closed: {
    width: 70,
  },
};

export const mainDrawerDimenResponsive = {
  open: {
    width: '27.7vw',
  },
  closed: {
    width: '6.5vw',
  },
};

export const leftDrawerDimenResponsive = {
  open: {
    width: '21.343vw',
  },
  closed: {
    width: '6.5vw',
  },
};

export const leftDrawerDimen = {
  open: {
    width: 230.5,
  },
  closed: {
    width: 70,
  },
};

export const rightDrawerDimenResponsive = {
  open: {
    width: '28.287vw',
  },
  closed: {
    width: '6.5vw',
  },
};
export const rightDrawerDimen = {
  open: {
    width: 305.5,
  },
  closed: {
    width: 70,
  },
};

export const mainAppBarDimenResponsive = {
  height: '5.556vw',
};
export const mainAppBarDimen = {
  height: 60,
};
export const toolBarDimenResponsive = {
  height: '4.444vw',
};
export const toolBarDimen = {
  height: 48,
};

export const bottomBarDimenResponsive = {
  height: '5.556vw',
};

export const bottomBarDimen = {
  height: 60,
};

export const toPixel = dimen => {
  let inPixel = '';
  if (typeof dimen === 'number') {
    inPixel = `${dimen}px`;
  } else {
    throw new Error('The dimension parameter provided is not a number');
  }
  return inPixel;
};

function pxToVw(pxValue, viewportWidth) {
  const vwValue = (pxValue / viewportWidth) * 100;
  return vwValue;
}

function pxToVh(pxValue, viewportHeight) {
  const vhValue = (pxValue / viewportHeight) * 100;
  return vhValue;
}

export const mainLogoDimenResponsive = {
  open: {
    height: '9.259vw',
    width: '9.259vw',
  },
  closed: {
    width: '4.630vw',
    height: '4.630vw',
  },
};

export const mainLogoDimen = {
  open: {
    height: 100,
    width: 100,
  },
  closed: {
    width: 50,
    height: 50,
  },
};
